import { render, staticRenderFns } from "./OrderComment.vue?vue&type=template&id=3d6653e6&"
import script from "./OrderComment.vue?vue&type=script&lang=js&"
export * from "./OrderComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports